import { TrailerUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/trailer_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

import { trailerStatusLabels } from '../enumLabels';

type TrailerUpdatedDetailProps = {
  event: TrailerUpdatedEvent;
};

export const TrailerUpdatedDetail = ({ event }: TrailerUpdatedDetailProps) => {
  const previous = event.previousTrailer;
  const current = event.updatedTrailer;

  if (!previous || !current) {
    return (
      <Col className="@TrailerUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'licensePlate',
      label: 'License Plate',
      previous: previous.licensePlate,
      current: current.licensePlate,
    },
    {
      field: 'status',
      label: 'Status',
      previous: trailerStatusLabels[previous.status],
      current: trailerStatusLabels[current.status],
    },
    {
      field: 'vin',
      label: 'VIN',
      previous: previous.vin,
      current: current.vin,
    },
    {
      field: 'capacity',
      label: 'Capacity',
      previous: previous.capacity ? String(previous.capacity) : '',
      current: current.capacity ? String(current.capacity) : '',
    },
    {
      field: 'country',
      label: 'Country',
      previous: previous.country,
      current: current.country,
    },
    {
      field: 'state',
      label: 'State',
      previous: previous.state,
      current: current.state,
    },
    {
      field: 'notes',
      label: 'Notes',
      previous: previous.notes,
      current: current.notes,
    },
    {
      field: 'transportationTypeId',
      label: 'Transportation Type ID',
      previous: previous.transportationTypeId?.value ?? '',
      current: current.transportationTypeId?.value ?? '',
    },
  ];

  return (
    <Col className="@TrailerUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Trailer</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay label="License Plate" value={current.licensePlate} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
